
import { userstats } from '../../../model/userstats';

export interface IState {
  stats?: userstats;
  loadingUserStats: boolean;
  errorFetchUserStats: boolean;
}

export const DefaultState = (): IState => ({
  stats: undefined,
  errorFetchUserStats: false,
  loadingUserStats: false,
})
